import classNames from "classnames";
import { Button } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";
import type { DataStructureTabId } from "./types";

type SidebarTabProps = {
  label: string;
  isActive: boolean;
  onClick: () => void;
};

const SidebarTab = ({ label, isActive, onClick }: SidebarTabProps) => {
  return (
    <Button
      variant="neutral"
      className={classNames(styles.sidebarTab, { [styles.sidebarTabActive]: isActive })}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

const ALL_TABS: { id: DataStructureTabId; label: string }[] = [
  { id: "gl", label: "GL data packages" },
  { id: "gpx", label: "GPX data packages" },
  { id: "date-ranges", label: "Date ranges" },
  { id: "primary-fields", label: "Primary fields" },
];

export type DataStructureSidebarProps = {
  activeTab: DataStructureTabId;
  onTabChange: (tab: DataStructureTabId) => void;
  visibleTabs?: readonly DataStructureTabId[];
};

export const DataStructureSidebar = ({
  activeTab,
  onTabChange,
  visibleTabs,
}: DataStructureSidebarProps) => {
  const tabs = visibleTabs ? ALL_TABS.filter((tab) => visibleTabs.includes(tab.id)) : ALL_TABS;

  return (
    <>
      {tabs.map((tab) => (
        <SidebarTab
          key={tab.id}
          label={tab.label}
          isActive={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        />
      ))}
    </>
  );
};
